import { focusRing } from "@decibeltrade/web-core/recipes";
import { css, cx } from "styled-system/css";

export const linkStyles = cx(
  css({
    textStyle: "body.md",
    color: "text.tertiary",
    textDecoration: "underline",
    textDecorationSkipInk: "none",
    textUnderlinePosition: "from-font",
    transitionPreset: "colors",
    _hover: {
      color: "text.primary",
    },
  }),
  focusRing(),
);

/** An override to style the `Button` component as a link. */
export const buttonToLinkStyles = cx(
  css({
    px: "0!",
    h: "[unset!]",
    "& span": { textStyle: "body.md!" },
    _before: { rounded: "250!" },
    _disabled: { color: "text.disabled!" },
  }),
  linkStyles,
);
